/**
 * Single source of truth for "can this user SEE Operational Base?".
 *
 *   • Super admins  → personal setting `show_operational_base` (default OFF).
 *                     They keep route access; only the links are hidden.
 *   • Everyone else → the per-org `operational_base_enabled` switch.
 *
 * Operational Base is never a landing destination — nothing navigates there
 * automatically for anyone.
 */
export function canSeeOperationalBase(user) {
    if (!user) return false;
    if (user.role === 'super_admin') return user.show_operational_base === true;
    return user.operational_base_enabled !== false;
}

export default canSeeOperationalBase;
